<template>
    <div class="app-container">
        <el-form :model="applicantProfile" ref="ruleForm" label-width="auto">
            <el-form-item label="姓名：" prop="name" :rules="{required: true, message: '不能为空', trigger: 'blur'}">
                <el-input v-model.trim="applicantProfile.name" clearable placeholder="姓名" autocomplete="off"/>
            </el-form-item>
            <el-form-item label="性别：" prop="gender" :rules="{required: true, message: '不能为空', trigger: 'blur'}">
                <el-radio-group v-model="applicantProfile.gender">
                    <el-radio :label="0">男</el-radio>
                    <el-radio :label='1'>女</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="邮箱：" prop="email" :rules="{required: true, message: '不能为空', trigger: 'blur'}">
                <el-input v-model.trim="applicantProfile.email" clearable placeholder="邮箱" autocomplete="off"/>
            </el-form-item>
            <el-form-item label="手机号：" prop="mobile" :rules="{required: true, message: '不能为空', trigger: 'blur'}">
                <el-input v-model="applicantProfile.mobile" maxlength="11" clearable placeholder="请输入"
                          autocomplete="off"/>
            </el-form-item>
            <el-form-item label="语种" prop="languageType" :rules="{required: true, message: '不能为空', trigger: 'change'}">
                <div style="display: flex;justify-content: flex-start;">
                <el-select v-model="applicantProfile.languageType" placeholder="请选择"  style="width:100%;">
                    <option label="英语" value="1"/>
                    <option label="小语种" value="2"/>
                </el-select>
                <el-select v-model="applicantProfile.englishLevel" placeholder="请选择"
                           style="width:100%;">
                    <el-option
                            v-for="item in englishOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                    />
                </el-select>
                <el-input v-model="applicantProfile.languageLevel" clearable placeholder="请输入" autocomplete="off"/>
                </div>
            </el-form-item>
            <el-form-item label="最高学历：" prop="educationLevel"
                          :rules="{required: true, message: '不能为空', trigger: 'blur'}">
                <el-select v-model="applicantProfile.educationLevel" filterable clearable placeholder="请选择"
                           style="width:100%;">
                    <el-option
                            v-for="item in educationOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                    />
                </el-select>
            </el-form-item>
            <el-form-item label="附件上传：">
                <el-upload
                        ref="IdentityCard"
                        :action="process + '/attachment/upload/file'"
                        :limit="1"
                        :headers="headers"
                        :data="uploadData"
                        :on-preview="handleUploadPreview"
                        :on-success="handleUploadSuccess"
                        :before-upload="beforeUpload"
                        :on-remove="handleRemove">
                    <el-button size="small" type="primary"><i class="el-icon-upload"/> 点击上传</el-button>
                </el-upload>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleConfirm">提交</el-button>
            </el-form-item>

        </el-form>
    </div>
</template>

<script>

    import {englishOptions} from "../const";
    import {educationOptions} from "../const";
    import { Message } from 'element-ui'

    export default {
        name: "Application.vue",
        data() {
            return {
                applicantProfile: {},
                attachments: [],
                englishOptions: englishOptions,
                educationOptions: educationOptions,
                process: process.env.VUE_APP_BASE_API,
                headers: {
                    userId: this.$route.query.userId
                },
                uploadData: {
                    uuid: '',
                    moduleName: 'applicant'
                },
            }
        },

        methods: {

            handleRemove(file, fileList) {
                if (this.attachments.length !== 0) {
                    this.attachments.forEach((item, index) => {
                        if (item.uuid === file.uid) {
                            this.attachments.splice(index, 1);
                        }
                    })
                }
            },

            beforeUpload(file) {
                this.uploadData.uuid = file.uid;
                const isLt5M = file.size / 1024 / 1024 < 10;
                if (!isLt5M) {
                  Message.error('上传附件大小不能超过 10MB!');
                }
                return isLt5M;
            },

            handleUploadSuccess(res, file) {
                this.attachments.push({
                    uuid: file.uid
                })
            },

            handleUploadPreview(file) {
                window.open(file.url) //blob格式地址
            },

            handleConfirm() {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.requestNet();
                    } else {
                        return Message.warning('请输入必填项！');
                    }
                })
            },

            async requestNet() {
                let {code} = await addMobileResume(this.applicantProfile, this.attachments, this.$route.query.userName, this.$route.query.userId).catch(() => Message.error('新增失败'));
                if (code === 200) {
                  Message.success('投递成功');
                    //todo 返回上一级路由
                }
            }

        }

    }
</script>

<style scoped>

</style>
